// extracted by mini-css-extract-plugin
module.exports = {"container":"_36ikf","text":"_23WDZ","pic":"_1SlsW","centered":"_1deHI"};